"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function List(_a) {
    var channel = _a.channel;
    var _b = ra_fetch_1.useApi('backend').index('emails', {
        channel_id: channel.id,
        page: 1,
        paginate: 10,
        details: true,
    }), ecaptures = _b[0], setEcaptures = _b[1], eparams = _b[2], setEParams = _b[3];
    var _c = ra_fetch_1.useApi('backend')
        .records(setEcaptures, ecaptures.data, 'id', 'id')
        .delete('emails', { channel_id: channel.id }), deleteEcaptures = _c[0], submitDeleteEcaptures = _c[1];
    var wrapper = react_1.useRef();
    function NextPage(page) {
        setEParams(__assign(__assign({}, eparams), { page: page }), page !== 1);
        updateScroll();
    }
    function updateScroll() {
        wrapper.current.scroll({
            top: wrapper.current.scrollHeight,
            behavior: 'smooth',
        });
    }
    return react_1.default.createElement("div", { className: 'grid max-h-full' },
        react_1.default.createElement("div", { className: 'storybook-ecaptures-list-wrapper', ref: wrapper },
            react_1.default.createElement(storybook_1.Lists.List, null, ecaptures.data.map(function (ecapture, index) {
                return react_1.default.createElement(storybook_1.Ecaptures.ListItem, { ecapture: ecapture, key: index, onDelete: function () { return submitDeleteEcaptures({ id: ecapture.id }); } });
            }))),
        ecaptures.meta.current_page !== ecaptures.meta.last_page && react_1.default.createElement(storybook_1.Buttons.Button, { type: 'secondary', onClick: function () { return NextPage(ecaptures.meta.current_page + 1); } }, "Laat meer adressen zien"),
        Boolean(ecaptures.data.length) && react_1.default.createElement(storybook_1.Buttons.Link, { className: 'mt-4', to: process.env.NEXT_PUBLIC_STORYBOOK_SERVICE_BACKEND_URL + "/emails/export?channel_id=" + channel.id, type: 'primary' }, "CSV Export"),
        !Boolean(ecaptures.data.length) && react_1.default.createElement(storybook_1.Texts.Small, { className: 'text-center' }, "Nog geen e-mailadressen verzameld"));
}
exports.default = List;
